import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';

export const PlanWrapper = styled(Stack)`
  border-radius: 4px;
  opacity: 0.5;
  outline: 1px solid ${({ theme }) => theme.colors.zinc_200};

  transition: all ease-in-out 0.3s;

  &:hover {
    opacity: 1;
    outline: 3px solid ${({ theme }) => theme.colors.skyblue_300};
  }

  &.is-active {
    opacity: 1;
    outline: 3px solid ${({ theme }) => theme.colors.skyblue_300};
  }

  &.is-disabled {
    background-color: ${({ theme }) => theme.colors.zinc_100};
    color: ${({ theme }) => theme.colors.zinc_400};

    &:hover {
      opacity: 0.5;
      outline: none;
    }
  }
`;

export const PlanTypeButton = styled.button`
  padding: 8px 32px;

  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 999px;
  color: ${({ theme }) => theme.colors.black};

  transition: all ease-in-out 0.3s;

  &.is-active {
    border: 1px solid ${({ theme }) => theme.colors.black};
    background-color: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
  }

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.black};
    background-color: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
  }
`;
